import { IBaseLayer } from 'shared';
import { Layer } from '.';
import { Permission } from './Permission.class';

export class Project {
  extent: string;
  id: number;
  name: string;
  public = false;
  slug: string;
  preview: any;
  layers: Layer[] = [];
  deletedLayers: string[] = [];
  resource_uri: string;
  crowdsource_layer: Layer;
  base_map: IBaseLayer;
  // права текущего пользователя
  permissions: any;
  // все права на проект
  subjectPermissions: Permission[] = [];
  deletedPermissions: any[] = [];
  deletedLayerPermissions: any[] = [];
  parameters: { search?: ProjectOption<SearchType>[], tools?: any } = {};

  constructor(options?: any) {
    if (options) {
      Object.assign(this, options);
    }
  }
}

export interface ProjectOption<T> {
  type: T;
  name: string;
  active: boolean;
  inExtent?: boolean;
}

export type SearchType = 'address' | 'layer' | 'objects';
